import logger from '@/modules/Logger';

export default {
  async setAudioDevice(deviceId) {
    return this.localAudioTrack.setDevice(deviceId).then(() => {
      logger.info('Microphone device is switched', { operation: 'device:switch', payload: { deviceId: deviceId } });
    }).then(() => {
      this.audioDevice = deviceId;
      return this.getMediaStream();
    }).catch(error => {
      logger.error('Error on switching microphone', { operation: 'device:switch', reason: error,event_type:47,lesson_id:this.lessonId });
      return { error }
    })
  }
}
